import React from "react";
import {
  TableCell,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Button,
  Checkbox,
} from "@mui/material";
import Events from "../../models/Events";
import Sapexports from "../../models/Sapexport";
import RestUtilities from "../../services/RestUtilities";
import { EventStatuses } from "../../models/EventStatus";
import { Temporal } from "@js-temporal/polyfill";
import Loader from "../../components/Loader";
import { UserRoles } from "../../models/UserRoles";
import { withRouter } from "../../components/Shared/withNavigate";
import Auth from "../../stores/Auth";

class Accounting extends React.Component<any, any> {
  public static OpenAccountsColumns: string[] = [
    "",
    "ID",
    "Bezeichnung",
    "Beschreibung",
    "Teilnehmer",
    "Datum",
    "Status",
  ];

  public static PerformedAccountingColumns: string[] = [
    "ID",
    "Datum",
    "Download",
  ];

  state = {
    openInvoices: [] as Events[],
    selected: [] as number[],
    generated: [] as Sapexports[],
    loading: false,
  };

  fetchOpenInvoices = (): void => {
    this.setState({ loading: true });
    RestUtilities.get<Events>(
      `/api/Events?eventStatusId=${EventStatuses.Lohnabrechnung}`
    ).then((resp) => {
      this.setState({ openInvoices: resp.content, loading: false });
    });
  };

  fetchGeneratedInvoices = (): void => {
    this.setState({ loading: true });
    RestUtilities.get<Sapexports>("/api/Invoices").then((resp) => {
      this.setState({ generated: resp.content, loading: false });
    });
  };

  generateInvoice = (): void => {
    const { selected } = this.state;
    this.setState({ loading: true });

    let formData = {
      ids: selected,
    };
    RestUtilities.post("/api/Invoices/GenerateInvoice", formData)
      .then((resp) => {
        this.fetchOpenInvoices();
        this.fetchGeneratedInvoices();
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  downloadInvoice = (id: number): void => {
    let url: string = `/api/Invoices/Download?id=${id}`;

    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          let fileName: string = "";
          let disposition = xhr.getResponseHeader("Content-Disposition");

          if (disposition != null) {
            let startIndex = disposition!.indexOf("filename=") + 9;
            fileName = disposition!.substring(21, disposition!.length);
            fileName = fileName.replace(/['"]+/g, "");
          }

          let blob = new Blob([this.response]);
          RestUtilities.saveAs(blob, fileName);
        }
      }
    };

    xhr.open("GET", url);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader('Authorization',`Bearer ${Auth.getToken()}`);
    xhr.responseType = "blob";
    xhr.send();
  };

  mapRowCells = (event: Events) => {
    const isSelected = this.isSelected(event.id);

    return (
      <TableRow
        hover
        onClick={(e) => this.handleClick(e, event.id)}
        key={event.id}
      >
        <TableCell padding="checkbox">
          <Checkbox
            checked={isSelected}
            style={{ color: "rgb(0, 155, 229)" }}
          />
        </TableCell>
        <TableCell>{event.id}</TableCell>
        <TableCell>{event.eventName}</TableCell>
        <TableCell>{event.eventDescription}</TableCell>
        <TableCell>{`${
          event.currentMembersCount != null ? event.currentMembersCount : 0
        }/${
          event.maxMembersCount != null ? event.maxMembersCount : 0
        }`}</TableCell>
        <TableCell>
          {`${new Date(event.eventFrom).toLocaleDateString(
            "de-DE"
          )} - ${new Date(event.eventTo).toLocaleDateString("de-DE")}`}
        </TableCell>
        <TableCell>{EventStatuses[event.eventStatusId]}</TableCell>
      </TableRow>
    );
  };

  mapGeneratedRowCells = (exports: Sapexports) => {
    return (
      <TableRow key={exports.id}>
        <TableCell>{exports.id}</TableCell>
        <TableCell>
          {Temporal.PlainDate.from(
            new Date(exports.createDate).toISOString().split('T')[0]
          ).toLocaleString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })}
        </TableCell>
        <TableCell>
          {
            <p
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                color: "blue",
              }}
              onClick={() => this.downloadInvoice(exports.id)}
            >
              Download
            </p>
          }
        </TableCell>
      </TableRow>
    );
  };

  handleClick = (event: any, id: number) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [] as number[];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = (id: number) => this.state.selected.indexOf(id) !== -1;

  componentDidMount() {
    this.fetchOpenInvoices();
    this.fetchGeneratedInvoices();
  }

  public render() {
    let openAccountsTableColumns = Accounting.OpenAccountsColumns.map((x) => {
      return <TableCell>{x}</TableCell>;
    });

    let performedAccountingTableColumns =
      Accounting.PerformedAccountingColumns.map((x) => {
        return <TableCell>{x}</TableCell>;
      });

    let openInvoices = this.state.openInvoices.map((x) => {
      return this.mapRowCells(x);
    });

    let generated = this.state.generated.map((x) => {
      return this.mapGeneratedRowCells(x);
    });

    return (
      <>
        <h2 className="mt-3 title">Abrechnung</h2>

        <div className="row">
          <h4>Offene Abrechnungen</h4>
        </div>
        <div className="row">
          <Table className="objects-table table">
            <TableHead>
              <TableRow>{openAccountsTableColumns}</TableRow>
            </TableHead>
            <TableBody>{openInvoices}</TableBody>
          </Table>
        </div>

        {this.props.role === UserRoles[UserRoles.Administrator] && (
          <div className="float-right">
            <Button
              variant="contained"
              color="primary"
              className="btnBlue"
              onClick={() => this.generateInvoice()}
            >
              Abrechnen
            </Button>
          </div>
        )}
        <div className="row mt-5">
          <h4>Durchgeführte Abrechnungen</h4>
        </div>
        <div className="row">
          <Table className="objects-table table">
            <TableHead>
              <TableRow>{performedAccountingTableColumns}</TableRow>
            </TableHead>
            <TableBody>{generated}</TableBody>
          </Table>
        </div>
        {this.state.loading && <Loader />}
      </>
    );
  }
}

export default withRouter(Accounting);
